import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/power-dialer.vue
var o = {
	name: "DtIconPowerDialer",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--power-dialer"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Power Dialer",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M8.891 2.636 5.716 5.5l1.335.12a.65.65 0 0 1 .58.768L7.22 8.563l3.208-2.9L9.09 5.61a.65.65 0 0 1-.614-.77l.414-2.204Zm.1-1.438c.462-.417 1.19-.009 1.075.603l-.531 2.826 1.788.07a.65.65 0 0 1 .41 1.131l-4.616 4.176c-.462.418-1.19.009-1.074-.604l.534-2.818-1.748-.156a.65.65 0 0 1-.378-1.13l4.54-4.098Z",
		fill: "currentColor"
	}, null, -1), r("path", {
		d: "M.502 2.968a.5.5 0 0 0 0 1h3.585a.5.5 0 1 0 0-1H.502ZM.5 5.5a.5.5 0 1 0 0 1h2.087a.5.5 0 0 0 0-1H.5Zm0 2.532a.5.5 0 1 0 0 1h4.045a.5.5 0 1 0 0-1H.5Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=power-dialer.js.map